import { GridFlexBox } from "../themes/themes";

export default function EmptySpace() {
    return (
        <GridFlexBox>
            <br /> <br /> <br /> <br />
        </GridFlexBox>
    );
}
